const middleware = ({ store }) => {
    const magicLink = store.state.authentication.magicLink;
    if (!magicLink)
        return;
    throw new Error('This page is not allowed for magic link users');
};
export default middleware;
